import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import MuiLink from "@mui/material/Link";
import DeleteIcon from "@mui/icons-material/Delete";
import MpgFileUpload from "../../../fileHandling/MpgFileUpload";

const LogoUploadField = ({
  rhfFormInstance,
  uploadFieldName = "logo_img",
  uploadLabel,
  removeLogo,
  setRemoveLogo,
  showExistingLogo,
  removeLogoTooltip = "Remove Logo",
  logoName,
  onDownloadLogo,
}) => {
  return (
    <Box>
      <MpgFileUpload
        name={uploadFieldName}
        label={uploadLabel}
        rhfFormInstance={rhfFormInstance}
      />

      {!removeLogo && !!showExistingLogo && (
        <Grid>
          <Tooltip title={removeLogoTooltip}>
            <IconButton
              aria-label="delete"
              onClick={() => {
                setRemoveLogo(true);
              }}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>

          <MuiLink onClick={onDownloadLogo}>{logoName}</MuiLink>
        </Grid>
      )}
    </Box>
  );
};

export default LogoUploadField;
